import React from "react";

import TermsOfUseContent from "../../components/pages/Terms-of-use/TermsOfUseContent";

function TermsOfUse() {
  return <TermsOfUseContent />;
}

export default TermsOfUse;
